module.exports = __webpack_public_path__ + "media/06 wrap.22fc3e69.mp3";